/*
 Create by you  2015-12-28
 */
"use strict";
angular.module('typesettingpagePageManageModule', [
        'batchOperationframeModule',
        "typesettingPageManageServiceModule"
    ])
    .controller('typesettingpagePageManageCtrl', editLayoutManageCtrl);
editLayoutManageCtrl.$injector = ["$scope", "$q", "$filter", "$timeout", "$modal", "$state", "$location", "$stateParams", "trsHttpService", "modalDialog", "myManuscriptService", 'initSingleSelecet', 'editingCenterService', 'trsspliceString', "initVersionService", "getNewsNameService", "productMangageMentNewspaperService", "typesettingPageManageService"];

function editLayoutManageCtrl($scope, $q, $filter, $timeout, $modal, $state, $location, $stateParams, trsHttpService, modalDialog, myManuscriptService, initSingleSelecet, editingCenterService, trsspliceString, initVersionService, getNewsNameService, productMangageMentNewspaperService, typesettingPageManageService) {
    initStatus();
    initData();
    /**
     * [getSiteRights description]获取每个站点的操作权限
     * @return null [description]
     */
    function getSiteRights() {
        productMangageMentNewspaperService.getRight($stateParams.paper, "", "papersetpaper").then(function(data) {
            $scope.status.right = data;
        });
    }

    //初始化状态
    function initStatus() {
        $scope.params = {
            "serviceid": "mlf_paperset",
            "methodname": "queryZhaoPaiBanMians",
            "PaperId": $stateParams.paper
        };
        $scope.selectedArray = [];
        $scope.status = {
            isTab: $location.path().split("/")[4],
            right: {},
            item: '',
            previousDieCi: "",
            batchOperateBtn: {
                "hoverStatus": "",
                "clickStatus": ""
            },
        };
        getNewsNameService.getNewsName($stateParams.paper).then(function(data) {
            $scope.status.item = data;
            $scope.channelName = data.SITEDESC;
        });
        getSiteRights();
    }

    //初始化数据
    function initData() {
        dieciDroplist().then(function(data) {
            requestData();
        });
        getDropDown();
    }

    function requestData(callback) {
        //$scope.loadingPromise = 
        trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'get').then(function(data) {
            if (angular.isFunction(callback)) {
                callback(data);
                $scope.selectedArray = [];
            } else {
                $scope.items = data.DATA;
                $scope.page = data.PAGER;
                angular.isDefined($scope.page) ? $scope.page.PAGESIZE =
                    $scope.page.PAGESIZE.toString() : $scope.page = {
                        "PAGESIZE": 0,
                        "ITEMCOUNT": 0
                    };
                $scope.selectedArray = [];
            }

        });
    }

    //全选
    $scope.selectAll = function() {
        $scope.selectedArray = $scope.selectedArray.length == $scope.items.length ? [] : [].concat($scope.items);
    };

    //单选
    $scope.selectDoc = function(item) {
        //item.selected ? $scope.selectedArray.push(item) : $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
        if ($scope.selectedArray.indexOf(item) < 0) {
            $scope.selectedArray.push(item);
        } else {
            $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
        }
    };

    function getDropDown() {
        //照排版面状态
        $scope.ZPLayoutStatus = initSingleSelecet.ZPLayoutStatus();
        $scope.ZPLayoutStatusSelected = angular.copy($scope.ZPLayoutStatus[0]);
    }

    //类型筛选
    $scope.queryZPLayoutStatus = function() {
        $scope.params.Status = $scope.ZPLayoutStatusSelected.value;
        requestData();
    };

    //搜索
    // $scope.fullTextSearch = function() {
    //     var searchParams = {
    //         PAGESIZE: $scope.page.PAGESIZE,
    //         PAGEINDEX: 1,
    //         searchFields: [{
    //             // searchField: $scope.iWoAllSelected.value,
    //             keywords: $scope.keywords
    //         }]
    //     };
    //     var params = {
    //         'serviceid': "mlf_essearch",
    //         'methodname': "query",
    //         'searchParams': searchParams
    //     };
    //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {});

    // };
    //搜索
    $scope.fullTextSearch = function() {
        $scope.params.ChnlDesc = $scope.keywords;
        requestData();
    };
    //新建照排版面
    $scope.newZPLayout = function() {
        $scope.status.previousDieCi = "";
        $scope.status.prviousBanMian = "";
        $scope.status.prviousJianChen = "";
        newZPLayoutFn();
    };

    function newZPLayoutFn(returnData) {
        var modalInstance = $modal.open({
            templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/newZPLayout/newZPLayout_tpl.html",
            resolve: {
                params: function() {
                    var params = {
                        selectedDieCi: $scope.status.previousDieCi,
                    };
                    return params;
                },
            },
            //scope: $scope,
            windowClass: 'new-zp-layout-window',
            backdrop: false,
            controller: "productManageMentNewZPLayoutCtrl"
        });
        modalInstance.result.then(function(result) {
            requestData();
            if (result != "save") {
                $scope.status.previousDieCi = result.previousDieCi;
                $scope.status.prviousBanMian = result.prviousBanMian;
                $scope.status.prviousJianChen = result.prviousJianChen;
                newZPLayoutFn();
            }
        });
    }

    //单个删除
    $scope.singleDelete = function(item) {
        modalDialog.confirmModal('提示信息', "确认删除?", function() {
            deleteFun(item.CHANNELID);
        });

    };

    //批量删除
    $scope.batchDelete = function() {
        // var modalInstance = $modal.open({
        //     templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/batchDel/batchDel_tpl.html",
        //     windowClass: "batchDelClass",
        //     backdrop: false,
        //     controller: "productManageMentBatchDelCtrl",
        //     scope: $scope,
        //     resolve: {
        //         delItems: function() {
        //             return $scope.selectedArray;
        //         },
        //         title: function() {
        //             return "删除";
        //         }
        //     }
        // });
        // modalInstance.result.then(function() {
        //     var delArray = trsspliceString.spliceString($scope.selectedArray,
        //         'CHANNELID', ',');
        //     deleteFun(delArray);
        // });
        var delArray = trsspliceString.spliceString($scope.selectedArray, 'CHANNELID', ',');
        modalDialog.confirmModal('提示信息', "确认删除?", function() {
            deleteFun(delArray);
        });
    };


    //删除方法
    function deleteFun(item) {
        $scope.params.serviceid = "mlf_paperset";
        $scope.params.methodname = "deleteDieCiOrBanMians";
        $scope.params.ObjectIds = item;
        requestData(function() {
            $scope.params.serviceid = "mlf_paperset";
            $scope.params.methodname = "queryZhaoPaiBanMians";
            requestData();
        });

    }

    //停用启用
    $scope.stopOrStart = function(item) {
        //启用
        if (item.STATUS == "-1") {
            modalDialog.confirmModal('提示信息', "确定启用？", function() {
                $scope.params.serviceid = "mlf_paperset";
                $scope.params.methodname = "startDieCiOrBanMian";
                $scope.params.ObjectId = item.CHANNELID;
                requestData(function() {
                    $scope.params.serviceid = "mlf_paperset";
                    $scope.params.methodname = "queryZhaoPaiBanMians";
                    requestData();
                });
            });
        }
        //停用
        if (item.STATUS === "0") {
            modalDialog.confirmModal('提示信息', "确定停用？", function() {
                $scope.params.serviceid = "mlf_paperset";
                $scope.params.methodname = "stopDeiCiOrBanMian";
                $scope.params.ObjectId = item.CHANNELID;
                requestData(function() {
                    $scope.params.serviceid = "mlf_paperset";
                    $scope.params.methodname = "queryZhaoPaiBanMians";
                    requestData();
                });
            });
        }
    };
    /**
     * [batchOperation 批量操作启用或停用]
     * @return {[type]} [description]
     */
    $scope.batchOperation = function() {
        var obj = trsspliceString.spliceString($scope.selectedArray, 'CHANNELID', ',');
        var sItemName = trsspliceString.spliceString($scope.selectedArray, 'CHNLDESC', '、');
        var aStatus = trsspliceString.spliceString($scope.selectedArray, 'STATUS', ',');
        var params = {
            "serviceid": "mlf_paperset",
            "ObjectIds": obj
        };
        var sTitle = "";
        if (aStatus.indexOf('0') < 0) {
            params.methodname = "startDieCisOrBanMians";
            sTitle = "确定启用？";
        } else if (aStatus.indexOf('-1') < 0) {
            params.methodname = "stopDeiCisOrBanMians";
            sTitle = "确定停用？";
        } else {
            modalDialog.alertType('请选择相同状态的版面', "", "warning", false, function() {
                $scope.selectedArray = [];
            });
            return;
        }
        batchOperationWindow(params, sTitle);
    };
    /**
     * [stopOperation description]批量停用站点
     * @return {[type]} [description]
     */
    $scope.stopOperation = function() {
        var obj = trsspliceString.spliceString($scope.selectedArray, 'CHANNELID', ',');
        var sItemName = trsspliceString.spliceString($scope.selectedArray, 'CHNLDESC', '、');
        var aStatus = trsspliceString.spliceString($scope.selectedArray, 'STATUS', ',');
        $scope.paramsStop = {
            "serviceid": "mlf_paperset",
            "ObjectIds": obj
        };
        var sTitle = "";
        if (aStatus.indexOf('0') < 0) {
            modalDialog.alertType('选择的站点已经停用', "", "warning", false, function() {
                $scope.selectedArray = [];
            });
            return;
        } else if (aStatus.indexOf('-1') < 0) {
            $scope.paramsStop.methodname = "stopDeiCisOrBanMians";
            sTitle = "确定停用？";
        } else {
            modalDialog.alertType('请选择相同状态的版面', "", "warning", false, function() {
                $scope.selectedArray = [];
            });
            return;
        }
        modalDialog.alertType('', '确定停用？', 'ask', true, function() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.paramsStop, 'get').then(function(data) {
                requestData();
                $scope.selectedArray = [];
            }, function(data) {
                requestData();
            });
        }, function() {
            $scope.selectedArray = [];
        });
        // batchOperationWindow(params, sTitle, sItemName);
    };
    /**
     * [startOperation description]批量启用站点
     * @return {[type]} [description]
     */
    $scope.startOperation = function() {
        var obj = trsspliceString.spliceString($scope.selectedArray, 'CHANNELID', ',');
        var sItemName = trsspliceString.spliceString($scope.selectedArray, 'CHNLDESC', '、');
        var aStatus = trsspliceString.spliceString($scope.selectedArray, 'STATUS', ',');
        $scope.paramsStart = {
            "serviceid": "mlf_paperset",
            "ObjectIds": obj
        };
        var sTitle = "";
        if (aStatus.indexOf('0') < 0) {
            $scope.paramsStart.methodname = "startDieCisOrBanMians";
        } else if (aStatus.indexOf('-1') < 0) {
            modalDialog.alertType('选择的站点已经启用', "", "warning", false, function() {
                $scope.selectedArray = [];
            });
            return;
        } else {
            modalDialog.alertType('请选择相同状态的版面', "", "warning", false, function() {
                $scope.selectedArray = [];
            });
            return;
        }
        modalDialog.alertType('', '确定启用？', 'ask', true, function() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.paramsStart, 'get').then(function(data) {
                requestData();
                $scope.selectedArray = [];
            }, function(data) {
                requestData();
            });
        }, function() {
            $scope.selectedArray = [];
        });
        // batchOperationWindow(params, sTitle, sItemName);
    };
    /**
     * [batchOperationWindow 启用/停用弹窗]
     * @param  {[Obj]} param   [请求参数]
     * @param  {[type]} title   [提示内容标题]
     * @param  {[type]} content [提示内容]
     * @return {[type]}         [description]
     */
    function batchOperationWindow(params, title, content) {
        var modalInstance = $modal.open({
            templateUrl: "./manageConfig/productManageMent/newspaper/service/batchOperation/batchOperation_tpl.html",
            windowClass: 'batch-Operation',
            backdrop: true,
            controller: "batchOperationframeCtrl",
            resolve: {
                sTitle: function() {
                    return title;
                },
                sContent: function() {
                    return content;
                }
            },
        });
        modalInstance.result.then(function() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                requestData();
                $scope.selectedArray = [];
            }, function(data) {
                requestData();
            });
        });
    }
    //编辑照排版面
    $scope.modifyZPLayout = function(item) {
        if (angular.isDefined($scope.status.right.zhaopaibanmian.bianji)) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/modifyZPLayout/modifyZPLayout_tpl.html",
                //scope: $scope,
                windowClass: 'new-zp-layout-window',
                backdrop: false,
                resolve: {
                    selectedItem: function() {
                        return item;
                    }
                },
                controller: "productManageMentModifyZPLayoutCtrl"
            });
            modalInstance.result.then(function() {
                requestData();
            });
        } else {
            modalDialog.alertType("您没有权限编辑该版面", "您没有权限编辑该版面", "error", false);
        }
    };

    //版面排序
    $scope.layoutRank = function() {
        if ($scope.selectedArray.length !== 1) {
            modalDialog.alertType("请仅选择一个频道", "", "warning", false);
            return;
        }
        var index = $scope.items.indexOf($scope.selectedArray[0]) + 1;
        /*typesettingPageManageService.ZPLayoutRank("newspaper", index, $scope.selectedArray[0], $scope.items, function(data) {
            if (data.ISSUCCESS == "true") {
                $state.go($state.current.name, $stateParams, { reload: true });
            }
        });*/
        $scope.sortInfo = {
            oldPosition: index, //原所在位置（列表序号）
            curItemName: $scope.selectedArray[0].CHNLDESC, //当前需要调整排序的选项的名称
            allCounts: $scope.items.length, //列表总数
            objId: $scope.selectedArray[0].CHANNELID, //站点、栏目id
            objType: 101, //站点:103;栏目:101
        }
        productMangageMentNewspaperService.commOrder($scope.sortInfo, function() {
            requestData();
        });
    };

    //初始化叠次下拉框
    function dieciDroplist() {
        var deffered = $q.defer();
        var params = {
            "serviceid": "mlf_paperset",
            "methodname": "queryDieCis",
            "PaperId": $stateParams.paper,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            var dieciDroplistJson = data;
            var options = [];
            options.push({
                "name": "全部叠次",
                "value": ""
            });
            for (var key in dieciDroplistJson) {
                options.push({
                    name: dieciDroplistJson[key].CHNLDESC,
                    value: dieciDroplistJson[key].CHANNELID
                });
            }
            $scope.dieciDroplistJson = options;
            $scope.dieciDroplistSelected = angular.copy($scope.dieciDroplistJson[0]);
            $scope.params.DieCiId = $scope.dieciDroplistSelected.value;
            deffered.resolve();
        });
        return deffered.promise;
    }
    $scope.getDieciData = function() {
        $scope.params.serviceid = "mlf_paperset";
        $scope.params.methodname = "queryZhaoPaiBanMians";
        $scope.params.PaperId = $stateParams.paper;
        $scope.params.DieCiId = $scope.dieciDroplistSelected.value;
        requestData();
    };
}